import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {DocumentsService} from '../../services/documents.service';
import {UrlService} from '../../services/url.service';
import {AuthenticationService} from '../../services/authentication.service';
import {untilDestroyed} from 'ngx-take-until-destroy';

@Component({
    templateUrl: 'documents.component.html'
})
export class DocumentsComponent implements OnInit, OnDestroy {

    constructor(public ds: DocumentsService,
                public urlService: UrlService,
                public authenticationService: AuthenticationService
    ) {
    }

    ngOnInit() {
        if (!this.authenticationService.userIsResident) {
            this.ds.getBuildings().pipe(untilDestroyed(this)).subscribe();
            this.ds.getUserGroups().pipe(untilDestroyed(this)).subscribe();
            this.ds.getCorporations().pipe(untilDestroyed(this)).subscribe();
        }
        this.urlService.setQueryParams('document', 1);
    }

    ngOnDestroy() {
        this.ds.urlService.onUrlChange.observers = [];
        this.ds.isDocumentDetailedModalShow = false;
        this.ds.selectedItemData = null;
        this.urlService.resetQueryParams();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.ds.emptyRowService.fillEmptyRow();
    }

    get isLoading() {
        return this.ds.isDocumentsLoading;
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents.component.ts